import { useEffect } from 'react';
import { useAuthStore } from './store/authStore';
import { LoginScreen } from './screens/LoginScreen';
import { NeedsContactScreen } from './screens/NeedsContactScreen';
import { OrderScreen } from './screens/OrderScreen';
import { isInsideTelegram } from './telegram/telegram';

export function App() {
  const { status, signIn, loadProfile } = useAuthStore();

  // Auto sign-in on boot using Telegram initData.
  useEffect(() => {
    if (status === 'idle') {
      void signIn();
    } else if (status === 'loading_profile') {
      void loadProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isInsideTelegram()) {
    return (
      <div className="centered-screen">
        <div className="brand">Carma</div>
        <p className="muted">
          Відкрийте додаток у Telegram через бота, щоб замовити поїздку.
        </p>
      </div>
    );
  }

  if (status === 'needs_contact') return <NeedsContactScreen />;
  if (status === 'authenticated') return <OrderScreen />;
  return <LoginScreen />;
}
